import Radio from '@material-ui/core/Radio';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { FieldImageType } from '~domain/flow/config/attributes-config';
import { styled } from '~ui-kit/styled-components';
import { theme } from '~ui-kit/theme';
import { Box } from './box.component';
import { FormControlLabel } from './form-control-label';
import { FormControlLabelWithImg } from './form-control-label-with-img';
import { Img } from './img.component';

interface Props {
  label: string;
  srcImg?: string;
  disabled?: boolean;
  fieldWidth?: string[];
}

export const LabelRadio: React.FunctionComponent<FieldRenderProps<string | boolean | number> & Props> = ({
  label,
  disabled,
  input: { checked, value, onChange },
  meta,
  fieldWidth = ['288px', '420px', '476px'],
  ...rest
}) => {
  return (
    <FormControlLabel
      control={
        <Radio
          {...rest}
          icon={<RadioButtonUncheckedIcon color="secondary" fontSize="medium" />}
          checkedIcon={<CheckedIcon fontSize="medium" />}
          onChange={onChange}
          checked={!!checked}
          value={value}
        />
      }
      disabled={disabled}
      width={fieldWidth}
      height={theme.sizes.inputHeight}
      label={label}
      checked={checked}
    />
  );
};

const Icon = styled(Img)<{ $checked?: boolean }>`
  vertical-align: middle;
  max-width: 54px;
  max-height: 54px;
  margin-bottom: 8px;
  filter: ${(props) => (props.$checked ? 'brightness(0) invert(1)' : 'invert(0)')};
`;

const RoundImage = styled(Img)`
  border-radius: 100%;
  max-width: 100px;
  max-height: 100px;
  margin-bottom: 4px;
`;

interface ImageRadioProps extends Props {
  imageType: FieldImageType;
}

export const ImageRadio: React.FunctionComponent<FieldRenderProps<string | boolean | number> & ImageRadioProps> = ({
  label,
  srcImg,
  imageType,
  input: { checked, value, onChange },
  fieldWidth = ['148px'],
  meta,
  ...rest
}) => {
  const verticalMargin: number = imageType === 'default' ? 3 : 0;
  return (
    <Box id="box-radio" flex-wrap="wrap" flexDirection="column">
      <FormControlLabelWithImg
        label=""
        control={
          <Box flex-wrap="wrap" flexDirection="column" justifyContent="center" alignItems="center">
            {imageType === 'default' && <Icon key="icon" $checked={checked} src={srcImg} />}
            {imageType === 'round' && <RoundImage src={srcImg} />}
            <Box
              alignItems="center"
              mx={2}
              my={verticalMargin}
              style={{
                textAlign: 'center',
                fontSize: '18px',
                height: '48px',
                color: checked ? '#ffffff' : theme.colors.secondaryDark,
              }}
            >
              {label}
            </Box>
            <Radio
              {...rest}
              icon={<RadioButtonUncheckedIcon color="secondary" fontSize="medium" />}
              checkedIcon={<CheckedIcon fontSize="medium" />}
              onChange={onChange}
              checked={!!checked}
              value={value}
            />
          </Box>
        }
        width={fieldWidth}
        height={['220px']}
        checked={checked}
      />
    </Box>
  );
};

const CheckedIcon = styled(RadioButtonCheckedIcon)`
  color: #ffffff;
`;
